<template>
  <svg
    class="c-spinner"
    :class="{ 'c-spinner--white': color === 'white' }"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="margin: auto; display: block; shape-rendering: auto"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      id="circle1"
      cx="50"
      cy="50"
      r="22.5936"
      fill="none"
      :stroke-width="strokeWidth"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1.4285714285714284s"
        values="0;30"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.7142857142857142s"
      />
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1.4285714285714284s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.7142857142857142s"
      />
    </circle>
    <circle
      id="circle2"
      cx="50"
      cy="50"
      r="6.68109"
      fill="none"
      :stroke-width="strokeWidth"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1.4285714285714284s"
        values="0;30"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
      />
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1.4285714285714284s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
      />
    </circle>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  color?: 'brand' | 'white'
  size?: 'small' | 'medium'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'brand',
  size: 'medium',
})

const strokeWidth = computed(() => (props.size === 'small' ? 4 : 2))
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CSpinner',
})
</script>
